import React, { useState } from 'react'
import { Button, message } from 'antd'
import { repairWrongPendingBatches } from '../../../../services/api/3dApi'

const ChangeStatusSewing = (props) => {
    const { batch, refreshBatchInfo } = props

    const _handleClick = async () => {
        const payload = {
            id: batch._id,
            status: "wait_to_sew"
        }

        if (batch.status === "pending") {
            const { data } = await repairWrongPendingBatches(payload)
            const { success, error } = data
            if (!success) {
                message.error(error)
            } else {
                refreshBatchInfo()
                message.success("Trạng thái lô đã đổi thành chờ may!!!")
            }
        } else {
            message.error("Chỉ đổi trạng thái Lô: Pending sang chờ may!!!")
        }
    }
    
    return (
        <Button
            type="primary"
            onClick={_handleClick}
            disabled={batch.status==="pending"? false: true}
            className="mr-3"
            style={{
                backgroundColor: '#76b52d',
                borderColor: '#76b52d',
                backgroundImage: 'linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent)',
                backgroundSize: "1rem 1rem",
                fontWeight: 600
            }}
        >
            Chờ may
        </Button>
    )
}

export default ChangeStatusSewing